import {
	Component,
	ElementRef,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	ChangeDetectorRef,
	AfterViewInit
} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {AppComponent} from '../app.component';
import {cloneDeep} from 'lodash';
import {EmailRegex, PhoneFrRegex, PasswordRegex, MustMatch} from '../const/utils';
import {Adresse} from "../Models/Adresse";
import {GoogleMap} from "@angular/google-maps";
import {User} from "../Models/User";
import {ROUTES_PATHS} from "../const/routes";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Component({
	selector: 'app-mon-compte',
	templateUrl: './mon-compte.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./mon-compte.component.less']
})
export class MonCompteComponent implements OnInit, AfterViewInit {
	@ViewChild('searchAdr') searchElementRef!: ElementRef;
	@ViewChild(GoogleMap) map!: GoogleMap;

	submittedFormUser = false;
	submittedFormPassword = false;
	textes: any;
	globalTxt: any;
	modalsTxt: any;
	userId: any = JSON.parse(localStorage.getItem("token")!).userId;
	user!: User;
	userForm!: FormGroup;
	mdpForm!: FormGroup;
	passwordTypeOld: string = 'password';
	passwordTypeNew: string = 'password';
	passwordTypeConfirm: string = 'password';
	passwordPictoOld: string = 'visibility';
	passwordPictoNew: string = 'visibility';
	passwordPictoConfirm: string = 'visibility';
	userRole!: number;
	address_obj!: Adresse;
	outOfSimu: boolean = false;

	get f() {
		return this.userForm.controls;
	}

	get fmdp() {
		return this.mdpForm.controls;
	}

	constructor(
		public app: AppComponent,
		private cd: ChangeDetectorRef,
		private formBuilder: FormBuilder,
		private formBuilderMdp: FormBuilder,
	) {
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.app.sharedToolsService.googleAddressToAdresse(this.searchElementRef, this.userForm, this.address_obj);
		}, 3000);
	}

	getPictoPassword(_param: any) {
		//console.log("getPictoPassword _param => ", _param);
		this.addClassActive(_param);

		let pictoToReturn = (_param.indexOf('_OLD') != -1) ? this.passwordPictoOld
			: (_param.indexOf('_NEW_CONFIRM') != -1) ? this.passwordPictoConfirm
				: this.passwordPictoNew;

		return pictoToReturn;
	}

	notInSitesDigitre(): boolean {
		return this.app.sharedToolsService.returnObjectSwitchRefId() !== SiteKeyEnum.CAPIFRANCE && this.app.sharedToolsService.returnObjectSwitchRefId() !== SiteKeyEnum.OPTIMHOME;
	}

	addClassActive(_param: any) {
		let eye = document.getElementById("svg_" + _param);
		if (this.mdpForm.value[_param] === '') {
			if (eye) eye.classList.remove('active');
		} else {
			if (eye) eye.classList.add('active');
		}
	}

	togglePasswordVisibility(_param: string) {
		//console.log("togglePasswordVisibility _param => ", _param);
		if (this.mdpForm.value[_param] === '') return;

		if (_param.indexOf('_OLD') != -1) {
			this.passwordTypeOld = this.passwordTypeOld === 'password' ? 'text' : 'password';
			this.passwordPictoOld = this.passwordPictoOld === 'visibility' ? 'visibility_off' : 'visibility';
			//console.log("this.passwordTypeOld ==> ", this.passwordTypeOld);

		} else if (_param.indexOf('_NEW_CONFIRM') != -1) {
			this.passwordTypeConfirm = this.passwordTypeConfirm === 'password' ? 'text' : 'password';
			this.passwordPictoConfirm = this.passwordPictoConfirm === 'visibility' ? 'visibility_off' : 'visibility';
			//console.log("this.passwordTypeConfirm ==> ", this.passwordTypeConfirm);

		} else {
			this.passwordTypeNew = this.passwordTypeNew === 'password' ? 'text' : 'password';
			this.passwordPictoNew = this.passwordPictoNew === 'visibility' ? 'visibility_off' : 'visibility';
			//console.log("this.passwordTypeNew ==> ", this.passwordTypeNew);
		}
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		//this.app.sharedToolsService.getUsrByID();
		console.log("this.userId ==> ", this.userId);

		let token = JSON.parse(localStorage.getItem("token")!);
		this.outOfSimu = (token?.outOfSimu) ? token.outOfSimu : false;

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get settings
		this.app.sharedToolsService.getSettings();

		// Get user by ID
		this.getUserDtoAltById(this.userId);

		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Replace in text blocAccessSimu.texteOutOfSimuDigitRE by name site
				let siteName:string = this.app.sharedToolsService.returnObjectSwitchRefId() === SiteKeyEnum.CAPIFRANCE ? "Capifrance" : "Optimhome";
				this.textes.blocAccessSimu.texteOutOfSimuDigitRE = this.textes.blocAccessSimu.texteOutOfSimuDigitRE.replace('[SITENAME]',siteName);

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get modals texts
					this.app.sharedToolsService.getModalTexts().subscribe(modalsTxt => {
						this.modalsTxt = cloneDeep(modalsTxt);
					});
				});
			})
	}

	getUserDtoAltById(_usrId: number) {
		this.app.apiToolsService.getUserDtoAltById(_usrId).subscribe(
			(user: any) => {
				console.log("res getUserDtoAltById ==> ", user);
				if (user) {
					///let _user: User = cloneDeep(user);
					this.user = cloneDeep(user);
					this.userRole = this.user.FCT_ID;
					// Save user role and user id in local storage for others pages
					localStorage.setItem("user_role", JSON.stringify(this.userRole));
					localStorage.setItem("user_id", JSON.stringify(this.user.USR_ID));

					// Get or create address
					this.address_obj = (this.user.USR_ADR) ? cloneDeep(this.user.USR_ADR) : new Adresse();

					// Create form for user
					this.userForm = this.formBuilder.group({
						USR_PRENOM: [this.user.USR_PRENOM, Validators.required],
						USR_NOM: [this.user.USR_NOM, Validators.required],
						USR_TEL_MOBILE: [this.user.USR_TEL_MOBILE, [Validators.required, Validators.pattern(PhoneFrRegex)]],
						USR_EMAIL: [this.user.USR_EMAIL, [Validators.required, Validators.pattern(EmailRegex)]],
						USR_NUMERO_EXTERNE: [this.user.USR_NUMERO_EXTERNE],
						USR_SIMU_TOTAL: [this.user.USR_SIMU_TOTAL],
						USR_SIMU_USED: [this.user.USR_SIMU_USED],
						adresseComplete: [this.user && !this.app.sharedToolsService.objectIdNull(this.user.USR_ADR, 'ADR_ID') &&
						this.user.USR_ADR?.ADR_CP !== null ? this.app.sharedToolsService.formatOriginalAdr(this.user.USR_ADR) : ''],
						USR_ADR: [this.address_obj],
						USR_ID_PARENT: [this.user && this.user.USR_ID_PARENT ? this.user?.USR_ID_PARENT : parseInt(this.userId)],
					});

					// Add address validators
					this.userForm.get('adresseComplete')?.valueChanges.subscribe((value) => {
						console.log("value ==> ", value);

						// If value is empty, reset address to null
						if (!value || value === '') {
							this.userForm.get('USR_ADR')?.setValue(null);
							return;
						}

						this.app.sharedToolsService.googleAddressToAdresse(this.searchElementRef, this.userForm, this.address_obj);
						//const adrControl = this.userForm.get('USR_ADR');
						//this.app.sharedToolsService.updateValidatorsAdrComplete(value, adrControl, this.address_obj);
					});

					// Create form for update password
					this.mdpForm = this.formBuilderMdp.group({	// password fields
						USR_MDP_OLD: ['', this.passwordRequired()],
						USR_MDP_NEW: ['', [this.passwordRequired(), Validators.pattern(PasswordRegex)]],
						USR_MDP_NEW_CONFIRM: ['', this.passwordRequired()]
					}, {
						validator: MustMatch('USR_MDP_NEW', 'USR_MDP_NEW_CONFIRM')
					});

					// ==> Add class text-white to the txt-surligne element
					this.cd.detectChanges();
					this.app.sharedToolsService.getClassWitheTextInSurligne();
				}
			}, err => {
				console.log('ERR getUserDtoAltById ==> ', err);
			}
		)
	}

	passwordRequired(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			return Validators.required(control);
		};
	}

	onSubmitUser() {
		console.log("this.userForm.value ==> ", this.userForm.value);

		this.submittedFormUser = true;
		//this.submittedMdp = this.userForm.value.usr_mdp_changes;

		if (this.userForm.invalid) {
			// Show an error message
			this.app.confirmDialogService.confirmThis(
				'',
				this.globalTxt.formFields.errorForm,
				'alert',
				'',
				() => {
				}, () => {
				}
			);
			return;
		}
		//let userDto = cloneDeep(this.user);
		let userDto: User = cloneDeep(this.user);
		console.log("userDto ==> ", userDto);
		userDto.USR_PRENOM = this.userForm.value.USR_PRENOM;
		userDto.USR_NOM = this.userForm.value.USR_NOM;
		userDto.USR_TEL_MOBILE = this.userForm.value.USR_TEL_MOBILE;
		userDto.USR_EMAIL = this.userForm.value.USR_EMAIL;
		userDto.USR_NUMERO_EXTERNE = this.userForm.value.USR_NUMERO_EXTERNE;
		userDto.USR_ADR = this.userForm.value.USR_ADR;
		userDto.USR_SIMU_TOTAL = this.userForm.value.USR_SIMU_TOTAL;
		userDto.USR_SIMU_USED = this.userForm.value.USR_SIMU_USED;
		userDto.USR_ID_PARENT = this.userForm.value.USR_ID_PARENT;

		//userDto.USR_ADR.ADR_ID = this.adresse.ADR_ID;
		if (userDto.USR_ADR && this.userForm.value.USR_ADR) {
			// console.log("this.address_obj ==> ", this.address_obj);
			// console.log("userDto.USR_ADR ==> ", userDto.USR_ADR);
			// console.log("userForm.value.USR_ADR ==> ", this.userForm.value.USR_ADR);

			userDto.USR_ADR!.ADR_ADRESSE_1 = this.userForm.value.USR_ADR.ADR_ADRESSE_1;
			userDto.USR_ADR!.ADR_CP = this.userForm.value.USR_ADR.ADR_CP;
			userDto.USR_ADR!.ADR_VILLE = this.userForm.value.USR_ADR.ADR_VILLE;
			userDto.USR_ADR!.PYS_CODE = this.userForm.value.USR_ADR.PYS_CODE;
			userDto.USR_ADR!.USR_ID = this.userId;
		} else {
			userDto.USR_ADR = null;
		}

		// Call Api update user
		this.updateUserDtoAlt(userDto);

	}

	updateUserDtoAlt(_userDto: any) {
		console.log("_userDto ==> ", _userDto);

		this.app.apiToolsService.updateUserDtoAlt(_userDto).subscribe(
			(res: any) => {
				console.log("res updateUserDtoAlt ==> ", res);
				if (res) {
					this.app.confirmDialogService.confirmThis(
						'', this.modalsTxt.modalSuccessMonCompte, 'alert', '',
						() => {
							this.getUserDtoAltById(res.Data?.USR_ID);
						},
						() => {
						});
				}
			}, err => {
				let errormsg: string = (err.status === 409) ? this.globalTxt.formFields.errorMsgExistEmail : err.error.Message;
				this.app.confirmDialogService.confirmThis('', errormsg, 'alert', '', () => {
				}, () => {
				});
				console.log('ERR updateUserDtoAlt ==> ', err);
			}
		)
	}

	onSubmitPassword() {
		console.log("this.mdpForm.value ==> ", this.mdpForm.value);

		this.submittedFormPassword = true;
		if (this.mdpForm.invalid) {
			// Show an error message
			this.app.confirmDialogService.confirmThis(
				'', this.globalTxt.formFields.errorForm, 'alert', '',
				() => {
				},
				() => {
				}
			);
			return;
		}
		// Call Api update password
		this.updatePassword(this.mdpForm.value.USR_MDP_OLD, this.mdpForm.value.USR_MDP_NEW);
	}

	updatePassword(_oldPassword: string, _newPassword: string) {
		// console.log("_oldPassword ==> ", _oldPassword);
		// console.log("_newPassword ==> ", _newPassword);
		this.app.apiToolsService.updatePassword(_oldPassword, _newPassword).subscribe(
			(res: any) => {
				console.log("res updatePassword ==> ", res);
				if (res) {
					this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalSuccessPassword, 'alert', '',
						() => {
							// Deconect user
							localStorage.clear();
							this.app.router.navigate(['/']);
						}, () => {
						});

				}
			}, err => {
				console.log('ERR updatePassword ==> ', err);
			}
		)
	}

	goToCalcOrProds() {
		let route_to_navigate = (this.outOfSimu) ? ROUTES_PATHS.PRODUITS : ROUTES_PATHS.WELCOME;
		this.app.router.navigate([route_to_navigate]);
	}
}
